import { Component } from '@angular/core';
import { RouterModule, RouterOutlet } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { TabsModule } from 'primeng/tabs';
import { TableComponent } from './shared/components/table/table.component';
import { ConfirmationPopupComponent } from './shared/components/confirmation-popup/confirmation-popup.component';
import { EmptyMessageComponent } from './shared/components/empty-message/empty-message.component';
import { Toast, ToastModule } from 'primeng/toast';
import { FileUploadComponent } from './shared/components/file-upload/file-upload.component';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    RouterModule,
    ToastModule,
    Toast,
    FileUploadComponent
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'lulu';
  // files = [
  //   {
  //     type: "image", file: "", image: "https://images.pexels.com/photos/358457/pexels-photo-358457.jpeg?_gl=1*1sforb5*_ga*MTgxMjkxNjA0NS4xNzUxOTY0MTA1*_ga_8JE65Q40S6*czE3NTE5NjQxMDUkbzEkZzEkdDE3NTE5NjQxMDYkajU5JGwwJGgw"
  //     , id: 1, fileSize: "60.9 KB", fileName: "Download.png", progress: 100, error: ""
  //   }
  // ]
}
